"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CondOperator;
(function (CondOperator) {
    CondOperator["EQUALS"] = "$eq";
    CondOperator["NOT_EQUALS"] = "$ne";
    CondOperator["GREATER_THAN"] = "$gt";
    CondOperator["LOWER_THAN"] = "$lt";
    CondOperator["GREATER_THAN_EQUALS"] = "$gte";
    CondOperator["LOWER_THAN_EQUALS"] = "$lte";
    CondOperator["STARTS"] = "$starts";
    CondOperator["ENDS"] = "$ends";
    CondOperator["CONTAINS"] = "$cont";
    CondOperator["EXCLUDES"] = "$excl";
    CondOperator["IN"] = "$in";
    CondOperator["NOT_IN"] = "$notin";
    CondOperator["IS_NULL"] = "$isnull";
    CondOperator["NOT_NULL"] = "$notnull";
    CondOperator["BETWEEN"] = "$between";
    CondOperator["EQUALS_LOW"] = "$eqL";
    CondOperator["NOT_EQUALS_LOW"] = "$neL";
    CondOperator["STARTS_LOW"] = "$startsL";
    CondOperator["ENDS_LOW"] = "$endsL";
    CondOperator["CONTAINS_LOW"] = "$contL";
    CondOperator["EXCLUDES_LOW"] = "$exclL";
    CondOperator["IN_LOW"] = "$inL";
    CondOperator["NOT_IN_LOW"] = "$notinL";
})(CondOperator = exports.CondOperator || (exports.CondOperator = {}));
